//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/global-reporting";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      as_of_date: moment().format("MM/DD/YYYY"),
      headers: [],
      fields: ["prop_name", "this_outstanding", "this_collected", "prepayments", "this_billed", "this_delinquency", "last_outstanding", "last_collected", "last_billed", "last_delinquency"],
      items: [],
      monthLabels: [moment().format("MMMM"), moment().subtract(1, "months").format("MMMM"), "Prior to " + moment().subtract(1, "months").format("MMMM")],
      includeBadDebt: true,
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("delinquency-report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });
    Event.$on("exportDelinquencyToExcel", function () {
      return _this.exportToExcel();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("delinquency-report");
    Event.$off("exportDelinquencyToExcel");
  },

  methods: {
    load: function load() {
      var _this2 = this;

      this.items = [];
      this.loading = true;
      this.monthLabels = [moment(this.as_of_date).format("MMMM"), moment(this.as_of_date).subtract(1, "months").format("MMMM"), "Prior to " + moment(this.as_of_date).subtract(1, "months").format("MMMM")];
      this.headers = ["Property", { title: moment(this.as_of_date).format("MMMM") + " Outstanding", filter: "toCurrency" }, { title: moment(this.as_of_date).format("MMMM") + " Collected", filter: "toCurrency" }, { title: moment(this.as_of_date).format("MMMM") + " Prepayments", filter: "toCurrency" }, { title: moment(this.as_of_date).format("MMMM") + " Billed", filter: "toCurrency" }, moment(this.as_of_date).format("MMMM") + " Delinquency", {
        title: moment(this.as_of_date).subtract(1, "months").format("MMMM") + " Outstanding",
        filter: "toCurrency"
      }, {
        title: moment(this.as_of_date).subtract(1, "months").format("MMMM") + " Collected",
        filter: "toCurrency"
      }, {
        title: moment(this.as_of_date).subtract(1, "months").format("MMMM") + " Billed",
        filter: "toCurrency"
      }, moment(this.as_of_date).subtract(1, "months").format("MMMM") + " Delinquency"];
      axios.post(BASE_URL + "/delinquency-report", {
        as_of_date: this.as_of_date,
        monthLabels: this.monthLabels,
        includeBadDebt: this.includeBadDebt
      }).then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
      });
    },
    applyFilter: function applyFilter() {
      this.load();
    },
    exportToExcel: function exportToExcel() {
      this.loading = true;

      var data = {
        exportExcel: true,
        as_of_date: this.as_of_date,
        monthLabels: this.monthLabels,
        includeBadDebt: this.includeBadDebt
      };

      this.createExport(data, BASE_URL + "/delinquency-report", "delinquency-percentage", ".xlsx");

      this.loading = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/DelinquencyReport.vue
// module id = W1G9
// module chunks = 0 1